<template>
  <v-container class="pa-0 px-3 ma-0">
     <v-row class="ma-0 pa-0">
        <v-col class="px-0 pr-5 py-0" cols="12" sm="12" md="6">
          <h1>Extrato de autorizações</h1>
          <p>Visualize os status e os dados das solicitações de autorização.</p>
        </v-col>
       </v-row>
    <v-row class="ma-0 pa-0">
        <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="2">
          <label>Data entre</label>
          <v-menu
            ref="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_inicio = parseDate(dateIFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
                <!-- :rules="formRules.required" -->
            </template>
            <v-date-picker color="primary" v-model="formData.data_inicio" @input="dateIFormatted = formatDate(formData.data_inicio)" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            ref="dtF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_final = parseDate(dateFFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
                <!-- :rules="formRules.required" -->
            </template>
            <v-date-picker color="primary" v-model="formData.data_final" @input="dateFFormatted = formatDate(formData.data_final)" no-title scrollable :min="formData.data_inicial"></v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
         <v-col class="pt-5 px-0 pr-sm-2 pb-0" cols="12" sm="6" md="3">
          <v-text-field
            v-model="formData.search_benef"
            prepend-inner-icon="fa-address-card"
            placeholder="Nome ou carteririnha do beneficiario"
            single-line
            outlined
            dense
            hide-details
            autocompleteoff
          ></v-text-field>
        </v-col>
        <v-col class="pt-5 px-0 pr-sm-2 pb-0" cols="12" sm="6" md="3">
          <v-text-field
            v-model="formData.search_guia"
            prepend-inner-icon="fa-search"
            placeholder="Número da guia"
            single-line
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
        </v-row>
    <v-row class="ma-0 pa-0">
      <v-col class="px-0 pr-5 py-0" cols="2" v-if="filtrarPorCarteiras">
            <label>Carteira</label>
            <v-select
                v-model="formData.carteira_id"
                :items="carteirasFilter"
                item-value="id"
                item-text="nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="resetData(false)"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="px-0 pr-5 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="formData.carteira_id!=null || prestadoresFilter.length==1"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id'); updateOperadoras()" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
    
      <v-col cols="12" sm="6" md="3" class="px-0 pr-5 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="formData.carteira_id!=null || operadorasFilter.length==1"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
     <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="2">
          <label>Tipo guia</label>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            v-model="formData.tipo_guia_id"
            dense
            :items="tipoguiasList"
            placeholder="Selecione"
            outlined
            item-text="descricao"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="2">
          <label>Status</label>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            v-model="formData.status"
            dense
            :items="statusSolicitacaoList"
            placeholder="Selecione"
            outlined
            item-text="descricao"
            item-value="id"
          ></v-select>
        </v-col>
      <v-col class="px-0 py-5" cols="12" sm="6" md="2">
        <v-btn
          max-width="100%"
          height="30px"
          small
          color="primary"
          depressed
          class="px-3"
          @click="filter(formData)"
          >Filtrar</v-btn
        >
        <v-btn
                outlined
                small 
                height="30px"
                color="primary"
                class="px-1 ml-1"
                depressed
                @click="resetData(true)"
                >Limpar Filtro</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
export default {
  data() {
    return {
      dateFFormatted: null,
      dateIFormatted: null,
      formData: {
        carteira_id: null,
        data_final: null,
        data_inicio: null,
        grupo_economico: null,
        operadora_ans_id: [],
        prestador_id: [],
        tipo_guia_id: null,
        search_benef: null,
        search_guia: null,
        status: null
      },
      operadorasFilter:[],
      prestadoresFilter:[],
      carteirasFilter: [],
      opts:{
        grupoEconomico: this.grupoEconomico, 
        modulo_operadora: 'autorizador',
        prestador_ids: []
      },
      status_solicitacao: [
        {id: null ,descricao:"Selecione", parametro: null},
        {id:1 ,descricao:"Autorizado", parametro: "autorizadas"},
        {id:7 ,descricao:"Autorizada parcialmete", parametro: "autorizadas_parcialmente"},
        {id:2 ,descricao:"Em análise", parametro: "em_analise"},
        {id:5 ,descricao:"Aguardando dados do prestador", parametro: "aguardando_dados_prestador"},
        {id:3 ,descricao:"Negada", parametro: "negadas" },
        {id:6 ,descricao:"Cancelada", parametro: "canceladas"},
        {id:-1,descricao:"Sem resposta", parametro: "sem_resposta"},
      ],
    }
  },
  computed: {
      ...mapState({
          formRules: (state) => state.formRules,
          filterData: (state) => state.autorizador.filterData,
          grupoEconomico: (state) => state.permissions.grupoEconomico,
          operadoras: (state) => state.autorizador.listOperadora
      }),
      ...mapGetters({
      getPrestadoresByGeco: "permissions/getPrestadoresByGeco"
    })
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler(val) {
        this.prestadoresFilter = this.$store.getters["permissions/getPrestadoresByGeco"]()
        this.formData.grupo_economico = val
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador_id = [this.prestadoresFilter[0].id]
        } 
        else {
          this.formData.prestador_id = [];
        }
        if(this.filtrarPorCarteiras) {
          this.updateCarteiras()
          }
      }
    },
    dataReferencia:{
      deep: true,
      handler(val){
        if(val){
          this.formData.data_inicio = val.data_inicio
          this.formData.data_final = val.data_final
          this.dateIFormatted = this.formatDate(val.data_inicio)
          this.dateFFormatted = this.formatDate(val.data_final)
        }
      }
    },
    // prestadores:{
    //   deep: true,
    //   handler(val){
    //     this.prestadoresFilter = Array.from(val)
    //     if (val.length==1) {
    //       this.formData.prestador_id = [this.prestadoresFilter[0].id]
    //     } 
    //     else {
    //       this.formData.prestador_id =  []
    //     }
    //   }
    // }, 
    operadoras:{
      deep: true,
      handler(val){
        this.operadorasFilter = Array.from(val)
        if (val.length==1) {
          this.formData.operadora_ans_id = [this.operadorasFilter[0].id]
        } 
        else {
          this.formData.operadora_ans_id =  this.formData.operadora_ans_id && this.formData.operadora_ans_id.length && this.operadorasFilter?  this.formData.operadora_ans_id.filter(el => this.operadorasFilter.getIndex(item=> item.id == el) > -1 ) : []
        }
      },
    },
    filtrarPorCarteiras:{
       deep: true,
      handler(val){
        if(val){
          this.updateCarteiras()
        }
      }
    }
  },
  mounted() {
    this.prestadoresFilter = this.$store.getters["permissions/getPrestadoresByGeco"]()
    this.formData.grupo_economico = this.grupoEconomico
    this.getOperadoras(this.opts)
    if(this.filtrarPorCarteiras) {
     this.updateCarteiras()
    }
    if (this.prestadoresFilter.length==1) {
      this.formData.prestador_id = [this.prestadoresFilter[0].id]
    } 
    this.filterChart();
  },
  methods: {
    filterChart() {
      if(this.filterData.periodo) {
        let status = this.status_solicitacao.find(el => el.parametro ==this.filterData.status).id
        this.formData.prestador_id = this.filterData.prestador_id? this.filterData.prestador_id: []
        this.formData.operadora_ans_id = this.filterData.operadora_ans_id? this.filterData.operadora_ans_id: []
        this.formData.status = status? status : null
        this.formData.data_inicio = this.filterData.data_inicio
        this.formData.data_final = this.filterData.data_final
        this.dateIFormatted = this.formatDate(this.filterData.data_inicio)
        this.dateFFormatted = this.formatDate(this.filterData.data_final)
      setTimeout(() => {
        this.$store.commit('autorizador/resetFilter')
        this.filter(this.formData)
      }, 50);
     }
    },
    ...mapActions('permissions', [
      "getOperadoras"
    ]),
    ...mapActions('recebiveis', [
      "getCarteiras"
    ]),
    resetData(all) {
        this.formData = {...{
          carteira_id: all? null : this.formData.carteira_id,
          data_final: null,
          data_inicio: null,
          grupo_economico: this.grupoEconomico,
          operadora_ans_id: [],
          prestador_id: this.prestadoresFilter.length==1? [this.prestadoresFilter[0].id] : [],
          tipo_guia_id: null,
          search_benef: null,
          search_guia: null,
          status: null}
        }
        this.dateIFormatted = null
        this.dateFFormatted = null
    },
    updateCarteiras(){
       let obj = {query:[ {modulo: 'Carteira', acao: 'getcarteiras', payload: 
      {grupo_economico: this.grupoEconomico, user: true}}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then(response => {
        if (!response || response.isAxiosError || response.erros.length) {
          this.$store.commit("hideLoader");
          return;
        }
        this.carteirasFilter = response.dados
        if(this.carteirasFilter.length) {
          this.carteirasFilter.unshift({id: null, nome: "Selecione"})
        }
      })

    },
    updateOperadoras(){
            this.getOperadoras({...this.opts, prestador_ids: this.formData.prestador_id})
        },
        toggleAutocomplete(item, campo) {
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
          //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
            this.$nextTick()
            return
        },
  },
  props: {
    dataReferencia: Object,
    filter: Function,
    filtrarPorCarteiras: { type: Boolean, default: false },
    formatDate: Function,
    nomeFiltroExterno: {
      default: null,
      type: String
    },
    parseDate: Function,
    statusSolicitacaoList: Array,
    tipoguiasList: Array,
  }
};
</script>
